module.exports = __webpack_public_path__ + "media/images/404-bg-02-666e834dd86f3cbd44a2b41e13d25a1f.png";